// REDESIGN 2024

import { navigationElement } from './navigationElements.ts';

interface InfoStripProps {
    infoStripElement: HTMLElement | null;
}

export const infoStrip = ({ infoStripElement }: InfoStripProps) => {
    window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY;

        handleInfoStrip({
            scrollTop,
            infoStripElement,
        });
    });
};

interface HandleInfoStripProps {
    scrollTop: number;
    infoStripElement: HTMLElement | null;
}
export const handleInfoStrip = ({
    scrollTop = 0,
    infoStripElement = null,
}: HandleInfoStripProps) => {
    if (!infoStripElement) return;

    const CLASS_NAVIGATION_WITH_INFO_STRIP = 'body--navigation-with-info-strip';

    // Pokud je infoStrip a doscrollujeme nahoru => zobrazit
    if (scrollTop > 0) {
        if (navigationElement && infoStripElement) {
            navigationElement.style.setProperty(
                'margin-top',
                `-${infoStripElement.clientHeight + 1}px`,
            );
        }

        // Inzerce (desktop): Odebrat třídu na posun brandingu
        document.body.classList.remove(CLASS_NAVIGATION_WITH_INFO_STRIP);
    } else {
        // Reset do výchozí pozice | v topu stránky
        if (navigationElement) {
            navigationElement.style.setProperty('margin-top', '0');
        }

        // Inzerce (desktop): Přidat třídu na posun brandingu
        document.body.classList.add(CLASS_NAVIGATION_WITH_INFO_STRIP);
    }
};
